<template>
  <v-card class="mb-1 ticket grow">
    <v-card-text :style="{ color: status }" style="border-left: 5px solid">
      <v-layout>
        <v-flex style="word-break: break-word">
          <div
            v-if="['studio7', 'ticket2', 'ustore', 'ttb'].includes(selectedBot.theme)"
            class="font-weight-bold pb-1"
          >
            TICKET ID: {{ ticket.id }}
          </div>
          <div class="font-weight-bold">{{ ticket.subject }}</div>
          <div class="caption">{{ ticket.details }}</div>
          <v-chip
            v-if="ticket.assignadminid"
            small
            color="primary"
            dark
            outline
            class="caption"
            style="height: 20px; font-size: 12px; margin: 8px 0 0"
          >
            {{ ticket.assignadminid || '-' }}
          </v-chip>
        </v-flex>

        <v-flex shrink>
          <v-layout v-if="!loadingAgentData" column style="max-width: 56px">
            <FormTicketManage
              :key="ticket.id"
              :ref="`editticket_${ticket.id}`"
              v-model="ticket"
              style="width: max-content"
              :livechat="true"
              :type="'edit'"
              :loading="loading"
              @editTicket="onEditTicket"
            />
            <v-btn
              color="primary"
              outline
              small
              fab
              :loading="loadingHistory"
              @click.stop="handleShowHistory(ticket.id)"
            >
              <em class="fas fa-history" />
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap class="mt-2">
        <v-flex align-center d-flex>
          <div class="caption grey--text">
            {{ ticket.starttime | DateFormat('DD/MM/YYYY HH:mm') }}
          </div>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <v-chip disabled class="white--text" small :color="status">{{ ticket.status }}</v-chip>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-dialog v-if="historyData" v-model="showHistory" persistent width="800px">
      <HistoryStatus
        v-if="showHistory"
        v-model="historyData"
        @close="handleCloseHistory"
      ></HistoryStatus>
    </v-dialog>
  </v-card>
</template>

<script>
import api from '@/api'
import EditTicketOnly from '@/components/view/template/ticket/EditTicket.vue'
import HistoryStatus from '@/components/view/template/ticket/HistoryStatus.vue'
import Ticket2Edit from '@/components/view/ticket2/management/TicketEdit.vue'
import FormTicketManage from '@/components/view/template/ticket/FormTicketManage.vue'
import EditTicketMonix from '@/components/view/template/ticket/EditTicketMonix.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: {
    EditTicketOnly,
    EditTicketMonix,
    Ticket2Edit,
    FormTicketManage,
    HistoryStatus
  },
  props: ['value', 'pageid'],
  data() {
    return {
      loading: false,
      ticket: this.value,
      loadingHistory: false,
      historyData: null,
      showHistory: false
    }
  },
  computed: {
    ...mapGetters({
      isMonix: 'isMonix',
      selectedBot: 'selectedBot',
      loadingAgentGroup: 'getLoadingAgentGroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      loadingAgent: 'getLoadingAgent'
    }),
    loadingAgentData() {
      return this.loadingAgentGroup || this.loadingAgentSubGroup || this.loadingAgent
    },
    status() {
      switch (this.ticket.status.trim().toLowerCase()) {
        case 'pending':
          return '#fb8c00'
        case 'closed':
          return '#e0e0e0'
        case 'cancelled':
          return '#ff5252'
        case 'cancelled by customer':
          return '#fd87ee'
        case 'answered':
          return '#2196f3'
        case 'open':
          return '#4CAF50'
        case 'close by yes sales':
          return '#e0e0e0'
        default:
          return ''
      }
    }
  },
  methods: {
    handleCloseHistory() {
      this.historyData = null
      this.showHistory = false
    },
    async handleShowHistory(id) {
      const vm = this
      vm.loadingHistory = true
      vm.showHistory = true
      await vm.handleGetTicketHistory(id)
    },
    async handleGetTicketHistory(id) {
      const vm = this
      try {
        const response = await api.ticket2GetTicketHistory({
          pageId: vm.selectedBot.pageid,
          ticketId: id
        })

        if (response) {
          vm.historyData = response.history
          vm.loadingHistory = false
        }
      } catch (error) {
        vm.loadingHistory = false
        console.error(error)
        return
      }
    },
    formatSec(endDate, startDate) {
      console.log({ endDate, startDate })
      try {
        const formatted = moment
          .utc(new Date(endDate) - new Date(startDate))
          .format('H ชั่วโมง m นาที s วินาที')
        return formatted
      } catch (error) {
        return '-'
      }
    },
    async onEditTicket(ticket) {
      this.ticket = ticket
      // var response = await this.getTicketById(ticket.id)
      // var index = this.tickets.findIndex(el => {
      //   return el.id == ticket.id
      // })
      // if (index != -1 && response.data && response.data.length > 0) {
      //   this.$set(this.tickets, index, response.data[0])
      // }
      this.$emit('editTicketSuccess')
    },
    getTicketById(id) {
      var data = {
        id: id,
        pageid: this.pageid
      }
      return new Promise((resolve, reject) => {
        api.getTicketById(data, (error, response) => {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket {
  &.grow {
    z-index: 6;
    transition: all 0.2s ease-in-out;
  }
  &.grow:hover {
    transform: scale(1.02);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/TicketItem.vue